import { render, staticRenderFns } from "./ChoiceTime.vue?vue&type=template&id=4cc5b308&scoped=true&"
import script from "./ChoiceTime.vue?vue&type=script&lang=ts&"
export * from "./ChoiceTime.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceTime.vue?vue&type=style&index=0&id=4cc5b308&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5b308",
  null
  
)

export default component.exports